import React, { useEffect } from "react";
import "../../../../../Assets/Styles/UserGuide.scss";

const FooterJPAsGuide = (props) => {
  useEffect(() => {
    document
      .getElementById("recently-viewed")
      .classList.add("footer-jpas-guide-is-open");

    if (document.getElementById("prev-row")) {
      document.getElementById("prev-row").scrollIntoView();
    }

    return () => {
      document
        .getElementById("recently-viewed")
        .classList.remove("footer-jpas-guide-is-open");
    };
  }, []);

  const toggleNextGuide = () => {
    props.ToggleNextDialog();
  };

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const togglePreviousGuide = () => {
    props.TogglePreviousDialog();
  };

  return (
    <div className="guide-dialog footer-jpas-guide">
      <i className="feather-x" onClick={() => props.CloseGuide()}></i>
      <p className="dialog-text">
        {translateText("walkthrough_homepage_footer_items")}
      </p>
      <section className="dialog-footer">
        <div className="steps-navs back" onClick={() => togglePreviousGuide()}>
          <i className="feather-arrow-left"></i>
          <p>{translateText("back")}</p>
        </div>
        <div className="indicators">
          <>
            {props.GuideHasAdditionalStep ? (
              <>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((Item, i) => (
                  <span
                    onClick={() => props.JumpToStep(i)}
                    className={
                      i === 4 ? "step-circle active-circle" : "step-circle"
                    }
                    id={"circle-" + parseInt(i)}
                  ></span>
                ))}
              </>
            ) : (
              <>
                {[1, 2, 3, 4, 5, 6, 7, 8].map((Item, i) => (
                  <span
                    onClick={() => props.JumpToStep(Item)}
                    className={
                      i === 3 ? "step-circle active-circle" : "step-circle"
                    }
                    id={"circle-" + parseInt(i + 1)}
                  ></span>
                ))}
              </>
            )}
          </>
        </div>
        <div className="steps-navs next" onClick={() => toggleNextGuide()}>
          <p>{translateText("next")}</p>
          <i className="feather-arrow-right"></i>
        </div>
      </section>
    </div>
  );
};

export default FooterJPAsGuide;
